"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M20 10H5.76L4 6.47V18h16z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M2.01 6 2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2M4 6.47 5.76 10H20v8H4z"
}, "1")], 'MovieTwoTone');